import './ShowMessage.css';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';

function ShowMessage() {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const showMessageObj = useSelector(state => state.userSlice.showMessageObj);

    const capitalizeFirstLetter = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    
    useEffect(() => {
        if (showMessageObj?.open && showMessageObj?.message?.length) {
            if (Array.isArray(showMessageObj.message)) {
                if (showMessageObj?.message[0]?.message?.length) {
                    enqueueSnackbar(capitalizeFirstLetter(showMessageObj?.message[0]?.message), { 
                        variant: showMessageObj?.status, 
                        autoHideDuration: 4000,
                        anchorOrigin: {
                            vertical: 'top',  
                            horizontal: 'center', 
                        },
                    });
                }
                if (showMessageObj?.message[1]?.message?.length) {
                    enqueueSnackbar(capitalizeFirstLetter(showMessageObj?.message[1]?.message), { 
                        variant: showMessageObj?.status, 
                        autoHideDuration: 4000,
                        anchorOrigin: {
                            vertical: 'top',  
                            horizontal: 'center', 
                        },
                    });
                }
                if (showMessageObj?.message[2]?.message?.length) {
                    enqueueSnackbar(capitalizeFirstLetter(showMessageObj?.message[2]?.message), { 
                        variant: showMessageObj?.status, 
                        autoHideDuration: 4000,
                        anchorOrigin: {
                            vertical: 'top',  
                            horizontal: 'center', 
                        },
                    });
                }
                if (showMessageObj?.message[3]?.message?.length) {
                    enqueueSnackbar(capitalizeFirstLetter(showMessageObj?.message[3]?.message), { 
                        variant: showMessageObj?.status, 
                        autoHideDuration: 4000,
                        anchorOrigin: {
                            vertical: 'top',  
                            horizontal: 'center', 
                        },
                    });
                }
                if (showMessageObj?.message[4]?.message?.length) {
                    enqueueSnackbar(capitalizeFirstLetter(showMessageObj?.message[4]?.message), { 
                        variant: showMessageObj?.status, 
                        autoHideDuration: 4000,
                        anchorOrigin: {
                            vertical: 'top',  
                            horizontal: 'center', 
                        },
                    });
                }
                if (showMessageObj?.message[5]?.message?.length) {
                    enqueueSnackbar(capitalizeFirstLetter(showMessageObj?.message[5]?.message), { 
                        variant: showMessageObj?.status, 
                        autoHideDuration: 4000,
                        anchorOrigin: {
                            vertical: 'top',  
                            horizontal: 'center', 
                        },
                    });
                }
                if (showMessageObj?.message[6]?.message?.length) {
                    enqueueSnackbar(capitalizeFirstLetter(showMessageObj?.message[6]?.message), { 
                        variant: showMessageObj?.status, 
                        autoHideDuration: 4000,
                        anchorOrigin: {
                            vertical: 'top',  
                            horizontal: 'center', 
                        },
                    });
                }
                if (showMessageObj?.message[7]?.message?.length) {
                    enqueueSnackbar(capitalizeFirstLetter(showMessageObj?.message[7]?.message), { 
                        variant: showMessageObj?.status, 
                        autoHideDuration: 4000,
                        anchorOrigin: {
                            vertical: 'top',  
                            horizontal: 'center', 
                        },
                    });
                }
            } else {
                enqueueSnackbar(capitalizeFirstLetter(showMessageObj.message), { 
                    variant: showMessageObj?.status, 
                    autoHideDuration: 4000,
                    anchorOrigin: {
                        vertical: 'top',  
                        horizontal: 'center', 
                    },
                });
            }
        }
    }, [showMessageObj]);

    return null;
}

export default ShowMessage;